import ColorHeading from './ColorHeading';

export default ColorHeading;
